import moment from "moment"
import styled from "styled-components"
import { ButtonPrimary } from "ui/base/Button/ButtonStyled"
import { Modal } from "ui/base/modal/Modal"
import { themeFontSize } from "ui/theme"

export const CancellationModal = ({ selectedBooking, show, handleClose, onCancel, onClose }) => {
  return (
    <Modal show={show} handleClose={handleClose} minHeight={200} maxWidth={500}>
      <Container>
        <Title>Do you want to move forward with the class cancellation?</Title>

        {selectedBooking?.slots?.length > 1 ? (
          <Description>
            This class is part of a multi-class booking. Canceling this
            class will automatically cancel the following classes:
          </Description>
        ) : null}

        {selectedBooking?.slots?.length > 1 ? (
          <Description>Class: {selectedBooking?.slots?.class_name}</Description>
        ) : null}

        {selectedBooking?.slots &&
          selectedBooking?.slots?.length > 1 &&
          selectedBooking?.slots?.map((slot, index) => (
            <BookingSlots key={slot?.id}>
              <p>{moment(slot?.class_date).format("MMM Do, YYYY")}</p>
              <span>{"-"}</span>
              <p>
                {moment(slot?.class_date + " " + slot?.class_time).format(
                  "h:mm A"
                )}
              </p>
            </BookingSlots>
          ))}

        <Description>
          If you cancel the class at this point, payment will be refunded to the
          user and all slots from this booking will be blocked.
        </Description>
        <ButtonContainer>
          <ButtonPrimary onClick={onCancel}>Yes</ButtonPrimary>

          <ButtonPrimary onClick={onClose} variant='outline'>
            No
          </ButtonPrimary>
        </ButtonContainer>
      </Container>
    </Modal>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  gap: 1rem;
  width: 100%;
`

const Title = styled.h2`
  font-size: ${themeFontSize("medium")};
  text-align: center;
`

const Description = styled.p`
  font-size: ${themeFontSize("regular")};
  text-align: left;
 
  font-weight: 400;
  font-size: 18px;
  line-height: 155%;
  letter-spacing: 0%;
  text-align: center;
`

const ClassList = styled.div`
  font-size: ${themeFontSize("small")};
  display: grid;
  gap: 0.5rem;
`

const ClassTitle = styled.h2`
  font-size: ${themeFontSize("medium")};
  text-align: center;
`

const ClassItem = styled.div`
  text-align: center;
`

const RefundInfo = styled.p`
  font-size: ${themeFontSize("regular")};
  text-align: center;
`

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;

  & > * {
    width: 100%;
  }

  margin-bottom: -1.5rem;
`
const BookingSlots = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;